<div class=" flex-display fullComponent" *ngIf="!isagreed">
  <div class=" float-L width-70 ">
    <div class="pr-96px pt-104px">
      <div class="pendingheading" tabindex="0">{{pc_header}}</div>
      <div class="useofpending">
        <span tabindex="0">{{content1TC}}</span><span class="highlight-blue border-bottom-help cursor-pointer" (click)="showTC()" (keyup.enter)="showTC()" tabindex="0">{{content2TC}}</span><span>{{content3TC}}</span>
      </div>
      <div class="flex-display">
        <button mat-button class="btn-secondary-action-close" (click)="homepageredirect()" (keyup.enter)="homepageredirect()" tabindex="0">{{pc_decline}}</button>
        <button mat-button class="btn-primary-action-accept" (click)="acceptTC()" (keyup.enter)="acceptTC()" tabindex="0">{{pc_agree}}</button>
      </div>
    </div>
  </div>
  <div class="rightfloat float-R">
    <div class="padding-right-pc">
      <div class="hyperlink-text highlight-blue border-bottom-help flex-display cursor-pointer right-Overlay" id="generalFeedback" appHostListenerClick>{{generalFeedback}}</div>
    </div>
  </div>
</div>
